import styled from 'styled-components';
import { Text } from 'shared/components/Text/Text';

export const VPPFAQStyled = styled.div`
  height: 100%;
`;

export const FAQWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    max-width: 555px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin-top: 18px;
    max-width: 636px;
  }
`;

export const Title = styled(Text)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    font-weight: 600;
  }
`;

export const BodyText = styled(Text)`
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;
